<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="cnps" class="font-light" >Numéro CNPS<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.cnps" placeholder="XXXXXXXXX" name="cnps" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="date" class="font-light" >Date<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="date" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="fonction" class="font-light" >Fonction<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.fonction" placeholder="" name="fonction" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="categorie" class="font-light" >Categorie<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.categorie" placeholder="" name="categorie" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                    <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Enregistrer</span>
                    </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <!-- <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div> -->
                <p class="text-gray-700 text-2xl mb-4 underline">N CNPS employeur : XXXXXX</p>

                <h2 class="text-3xl font-semibold text-gray-900 text-center my-16 underline">CERTIFICAT DE TRAVAIL</h2>

                <div class="mb-4">
                    <p class="mb-10 text-gray-700 text-2xl">
                        Nous, soussignés, International University of Grand-Bassam (IUGB), certifions que <span class="font-bold">{{ form.nom ?? "TITRE NOMS ET PRENOMS" }}</span>, numéro CNPS <span class="font-bold">{{ form.cnps ?? "XXXXXXXXXXXXX" }}</span>, a été employé par notre institution en qualité de <span class="font-bold">{{ form.fonction ?? "FONCTION" }}</span>, <span class="font-bold">{{ form.categorie ?? "CATEGORIE" }}</span>, <span class="font-bold">{{ form.startDate ?? "DATES" }}</span>.
                    </p>
                    <p class="mb-10 text-gray-700 text-2xl">
                        Il/Elle nous quitte ce jour libre de tout engagement.
                    </p>
                    <p class="mb-16 text-gray-700 text-2xl">
                        En foi de quoi, le présent certificat lui est délivré pour servir et valoir ce que de droit.
                    </p>
                </div>

                <div class="text-right text-2xl">
                    <p class="text-gray-700 mb-32">Fait à Grand-Bassam, le <span class="font-bold">DATE</span></p>
                    <p class="text-gray-700 mr-32 font-bold">SIGNATURE</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "CertificatTravail",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                cnps: null,
                startDate: null,
                fonction: null,
                categorie: null
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.cnps = null;
            this.form.startDate = null;
            this.form.fonction = null;
            this.form.categorie = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":18,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>